import { Divider } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { formatText } from "../../utils";

function PlannedCard() {
   
  const url = "api/v2/dashboard/getAllDashboardData";
  const data = useSelector((state) => state.fetch.data[url] || []);


  return (
    <div className="p-[1.25rem] rounded-[.75rem] bg-white w-full">
      <div className="flex flex-wrap items-stretch gap-[1.25rem] w-full">
 
      {data?.projectData &&
        data?.projectData?.map((item,index) => (
            <>
            <div key={index} className="flex-1 min-w-[10rem]"> 
            <div className="text-[#050505] text-[.875rem] font-[400] font-roboto">
              {formatText(item?.title)}
            </div>
            <div className="mt-[2rem] flex justify-between items-center">
              <span className="text-[#050505] font-interSans text-[1.5rem] font-[500]">
                {item?.count}
              </span>
              <span className="flex items-center "> 
                {item?.percentage > 0 ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_5753_84276)">
                      <path
                        d="M13.3334 5.21875L15.2417 7.12708L11.1751 11.1937L7.84175 7.86042L1.66675 14.0437L2.84175 15.2188L7.84175 10.2188L11.1751 13.5521L16.4251 8.31042L18.3334 10.2188V5.21875H13.3334Z"
                        fill="#4FAD5B"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_5753_84276">
                        <rect
                          width="20"
                          height="20"
                          fill="white"
                          transform="translate(0 0.21875)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                ) : item?.percentage < 0 ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_5753_84287)">
                      <path
                        d="M14.0002 15.2188L15.9085 13.3104L11.8418 9.24375L8.5085 12.5771L2.3335 6.39375L3.5085 5.21875L8.5085 10.2188L11.8418 6.88542L17.0918 12.1271L19.0002 10.2188V15.2188H14.0002Z"
                        fill="#D92D20"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_5753_84287">
                        <rect
                          width="20"
                          height="20"
                          fill="white"
                          transform="translate(0.666748 0.21875)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                ) : null}
                  {item?.percentage}%
              </span>
            </div> 
          </div> 
          {index !== data?.projectData?.length - 1 && ( 
           <span className="lg:h-[5rem] h-0 lg:w-0 w-full lg:border-l border-b border-[#D6E1F5] lg:mx-[2.5rem] "> 
           </span>
            )}
          </>
        ))}
    </div>
    </div>
  );
}

export default PlannedCard;
